import { CLASS_BOARD_DETAILS } from 'app/view/react_components/aside_panel/boardDetails/constants';
import * as React from 'react';
import './_MoveTo.scss'
import { IMoveToProps } from './types';
import {
    BOARD_BUTTON_MOVE_TO,
    DRIVES_COLUMN_TITLE,
    MOVE_TO_BUTTON,
    MOVE_TO_TEXT,
    MOVE_TO_TEXT_EXTRA
} from './constants';
import { Button, ButtonDropdown, Icon, LoaderBlock } from 'kui';
import { MoveToColumn } from '../../../../../../base/components/MoveTo/components/MoveToColumn/MoveToColumn';
import {
    ButtonUpgradeMyPlanHOC
} from '../../../../../../dialogs/openBoards/hocs/ButtonUpgradeMyPlanHOC/ButtonUpgradeMyPlanHOC';
import {
    ButtonGivePermissionsSharedDrivesHOC
} from '../../../../../../dialogs/openBoards/hocs/ButtonGivePermissionsSharedDrivesHOC/ButtonGivePermissionsSharedDrivesHOC';

export function MoveTo ({
    isShow,
    planBlocker,
    scopesBlocker,
    onLoadItems,
    onMoveTo,
}: IMoveToProps) {
    const className = CLASS_BOARD_DETAILS + '-move-to';
    const classDropdown = className + '__dd';

    const [isOpened, setOpened] = React.useState(null);
    const [items, setItems] = React.useState(null);
    const [isLoading, setLoading] = React.useState(false);

    const onOpen = () => setOpened(true);
    const onClose = () => {
        setOpened(false);
        setLoading(false)
    }

    const onBoardClick = (index: number) => {
        const driveId = items[index].id;
        onMoveTo(driveId).then(() => {
            onClose();
        });
    };

    React.useEffect(() => {
        if (isLoading || !isOpened) return;

        setLoading(true);
        onLoadItems().then((result) => {
            setItems(result);
            setLoading(false);
        });
    }, [isOpened, scopesBlocker, planBlocker]);

    if (!isShow) return null;

    return (
        <div className={className}>
            <div className={className + '__text'}>
                {MOVE_TO_TEXT}{!!planBlocker || !!scopesBlocker ? '*' : '.'}
            </div>
            <ButtonDropdown
                className={className + '__bd'}
                dropdownClassName={classDropdown}
                opened={isOpened}
                onOpen={onOpen}
                onClose={onClose}
                disabled={!!planBlocker || !!scopesBlocker}
            >
                <Button disabled={!!planBlocker || !!scopesBlocker}>
                    {MOVE_TO_BUTTON}
                </Button>
                <>
                    <div className={classDropdown + '-header'}>
                        <div className={classDropdown + '-title'}>{BOARD_BUTTON_MOVE_TO}</div>
                        <Button
                            className={classDropdown + '-close'}
                            variant={'icon'}
                            onClick={onClose}
                        >
                            <Icon xlink={'close'} size={24}/>
                        </Button>
                    </div>
                    {
                        isLoading
                            ? <LoaderBlock className={className + '__loader'}/>
                            : items && items.length ? <MoveToColumn
                                title={DRIVES_COLUMN_TITLE}
                                items={items}
                                typeColumn={DRIVES_COLUMN_TITLE}
                                onClick={onBoardClick}
                            /> : <div/>
                    }
                </>
            </ButtonDropdown>
            {(!!planBlocker || !!scopesBlocker) &&
                <div className={className + '__blocker'}>
                    <div className={className + '__text'}>
                        {MOVE_TO_TEXT_EXTRA}
                    </div>
                    {planBlocker
                        ? <ButtonUpgradeMyPlanHOC size={null} />
                        : <ButtonGivePermissionsSharedDrivesHOC size={null} />
                    }
                </div>
            }
        </div>
    );
}
